"use client";
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onClick={onClose}></div>
      <div className="relative bg-white text-dark02 dark:bg-gray-900 p-10 shadow-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto sm:w-11/12 z-50  mx-4">
        <div className="flex justify-between items-center border-b-4 pb-2 mb-4 border-matco">
          <h2 className="text-3xl font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="p-2 h-10 w-10 transition text-center justify-center text-3xl text-gray-500 hover:text-gray-700 font-bold"
            aria-label="Cerrar modal"
          >×
          </button>
        </div>

        {/* Contenido dinámico */}
        <div>{children}</div>
      </div>
    </div>
  );
};
export default Modal;

